export default "__VITE_ASSET__BQTMjVmA__"